var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.58 10.46L38.8 7.1C38.26 6.42 37.44 6 36.5 6H12.5C11.56 6 10.74 6.42 10.18 7.1L7.42 10.46C6.84 11.14 6.5 12.04 6.5 13V38C6.5 40.2 8.3 42 10.5 42H38.5C40.7 42 42.5 40.2 42.5 38V13C42.5 12.04 42.16 11.14 41.58 10.46ZM24.5 35L13.5 24H20.5V20H28.5V24H35.5L24.5 35ZM10.74 10L12.36 8H36.36L38.24 10H10.74Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveModalIcon);
export default __webpack_public_path__ + "static/media/ArchiveModalIcon.5cf51cd02eb8663b61f5a8894edc770c.svg";
export { ForwardRef as ReactComponent };